import { RequirementParameterListRequest as ParameterListRequestDto, RequirementParameterRequest as ParameterRequestDto, RequirementParameterResponse } from "lib-klab-sdks";
import { RequirementParameter, RequirementParameterListRequest, RequirementParameterPage, RequirementParameterRequest } from "../../../domain/models/requirement/requirement-parameter.model";

export function mapRequirementParameter(source: RequirementParameterResponse): RequirementParameter {
  return {
    id: source.requirementParameterId,
    companyId: source.companyId,
    paramKey: source.paramKey,
    paramValue: source.paramValue,
    dataType: source.dataType,
    description: source.description,
    updatedBy: source.updatedBy,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapRequirementParameterRequest(request: RequirementParameterRequest): ParameterRequestDto {
  return {
    companyId: request.companyId,
    paramKey: request.paramKey,
    paramValue: request.paramValue,
    dataType: request.dataType,
    description: request.description,
  };
}

export function mapRequirementParameterListRequest(request: RequirementParameterListRequest): ParameterListRequestDto {
  return { companyId: request.companyId, paramKey: request.paramKey, limit: request.limit, offset: request.offset };
}

export function mapRequirementParameterPage(source: {
  readonly items: readonly RequirementParameterResponse[];
  readonly limit: number;
  readonly offset: number;
  readonly hasNext: boolean;
  readonly total?: number;
}): RequirementParameterPage {
  return {
    items: source.items.map(mapRequirementParameter),
    limit: source.limit,
    offset: source.offset,
    hasNext: source.hasNext,
    total: source.total,
  };
}
